/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { SettingOutlined } from '@ant-design/icons';
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import PermissionApi from 'apis/PermissionApi';
import {
  default as RoleBasedAPI,
  default as RoleBasedAuth,
} from 'apis/RoleBasedAPI';
import UserApi, { UpdateUserVars } from 'apis/UserClient';
import Button from 'components/Button';
import MainLayout from 'components/Modules/Layout/MainLayout';
import UserModal from 'components/Modules/User/UserModal';
import UserPlantModal from 'components/Modules/User/UserPlantModal';
import useQueryParam from 'hooks/useQueryPrams';
import { IGetUserQuery, IUser } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import handleError401 from 'utils/handleError401';
import { HocChangePagination } from 'utils/HocChangePagination';
import { openNotificationWithIcon } from 'utils/notification';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import { EditIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import { convertRole } from 'mock/route-mangagement';
import UserImportPlant from 'components/Modules/User/UserImportPlant';
import { useForm } from 'antd/es/form/Form';
import { isArray } from 'lodash';

const { Option } = Select;

export default function UserManagementPage(): JSX.Element {
  const [form] = useForm();
  const [isPermissionModalVisible, setIsPermissionModalVisible] =
    useState<boolean>(false);
  const [isUserPlantModalVisible, setIsUserPlantModalVisible] =
    useState<boolean>(false);
  const [isImportModalVisible, setIsImportModalVisible] =
    useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const [roles, setRoles] = useState([]);

  const history = useHistory();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const queryParam = useQueryParam();
  //console.log('queryParam', queryParam);
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  // const search = queryParam.get('search') || undefined;
  // const fullName = queryParam.get('fullName') || undefined;
  // const email = queryParam.get('email') || undefined;
  // const jobTitleCode = queryParam.get('jobTitleCode') || undefined;
  // const departmentCode = queryParam.get('departmentCode') || undefined;
  // const plantCode = queryParam.get('plantCode') || undefined;

  const userParams: IGetUserQuery = {
    page,
    page_size,
    ...formSubmitParams,
  };

  const params = JSON.parse(JSON.stringify(userParams));
  const {
    data,
    mutate: userRefetch,
    isLoading: getUsersLoading,
  } = useMutation(['getUsers', userParams], () =>
    RoleBasedAuth.getUsers(params)
  );

  const { data: groupData } = useQuery(
    'getGroups',
    () => PermissionApi.getGroups({ page: 1, page_size: 9999 }),
    {
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  const { mutate: setRole, isLoading: setRoleLoading } = useMutation(
    RoleBasedAPI.updateUserByHS,
    {
      onSuccess: () => {
        userRefetch();
        openNotificationWithIcon('success', 'Cập nhật quyền thành công!');
        setIsPermissionModalVisible(false);
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', error.response.data.message[0]);
      },
    }
  );

  const { mutate: assignGroups, isLoading: processing } = useMutation(
    PermissionApi.assignUserGroups,
    {
      onSuccess: () => {
        userRefetch();
        openNotificationWithIcon('success', 'Cấp quyền cho user thành công');
        setIsPermissionModalVisible(false);
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', error.response.data.message[0]);
      },
    }
  );

  const { mutate: setUserPlant, isLoading: setUserPlantLoading } = useMutation(
    UserApi.updateUser,
    {
      onSuccess: () => {
        userRefetch();
        openNotificationWithIcon('success', 'Cập nhật thông tin thành công!');
        setIsUserPlantModalVisible(false);
      },
      onError: (error: any) => {
        openNotificationWithIcon('error', error.response.data.message[0]);
      },
    }
  );

  useQuery('getRoles', () => RoleBasedAuth.getRoles(), {
    onSuccess: (response: any) => {
      setRoles(response?.data);
    },
    onError: (error: any) => {
      // if (error.response.data.status === 401) {
      //   handleError401();
      // }
    },
  });

  const handleUpdateUser = ({
    id,
    role,
    groups,
    plantCode,
    plantCodesManaging,
  }: any) => {
    const checkRoleArr = role ? String(role) : null;
    const checkGroupsArr = groups ? String(groups) : null;
    // setRole({ userId: id, role: checkRoleArr, groups: checkGroupsArr });

    const userParam: any = {
      action: 'UPDATE',
      employeeId: currentUser?.id,
      fullName: currentUser?.fullName,
      email: currentUser?.email,
      jobTitleCode: currentUser?.jobTitleCode,
      jobTitle: currentUser?.jobTitle,
      plantCode: plantCode,
      departmentCode: currentUser?.departmentCode,
      departmentName: currentUser?.departmentName,
      divisionCode: currentUser?.divisionCode,
      division: currentUser?.division,
      organization: currentUser?.organization,
      phoneNumber: currentUser?.phoneNumber,
      managerId: 0,
      managerEmail: currentUser?.managerEmail,
      role: checkRoleArr ? checkRoleArr : null,
      groups: checkGroupsArr ? checkGroupsArr : null,
      ...(plantCodesManaging != undefined &&
        typeof plantCodesManaging === 'string' && {
          plantCodesManaging: plantCodesManaging.split(';'),
        }),
    };
    setRole(userParam);
    // setCurrentUser({ ...currentUser, role: [role], groups: [groups] });

    // if (!currentUser) return;
    // let isNotUpdateGroups = true;
    // let isNotUpdateGroup = true;

    // const payload = {
    //   id: currentUser?.id,
    //   group: data.group,
    // };

    // if (data.groups) {
    //   const equal =
    //     JSON.stringify(data?.groups?.sort()) ===
    //     JSON.stringify(currentUser?.groups?.sort());
    //   if (!equal) {
    //     assignGroups({ userId: currentUser.id, groups: data.groups });
    //     isNotUpdateGroups = false;
    //   }
    // }

    // if (data.group !== currentUser.group) {
    //   setRole(payload);
    //   isNotUpdateGroup = false;
    // }

    // if (isNotUpdateGroups && isNotUpdateGroup)
    //   setIsPermissionModalVisible(false);
  };

  const handleUpdateUserPlant = (data: any) => {
    if (!currentUser) return;
    const payload: UpdateUserVars = {
      userId: currentUser?.id,
      plantCode: data.plantCode,
      vehicleType: data.vehicleType,
    };

    setUserPlant(payload);
  };

  const handleImportPlantASM = () => {
    console.log();
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 70,
    },
    {
      title: 'Plant Code',
      dataIndex: 'plantCode',
      width: 70,
    },
    {
      title: 'Họ tên người dùng',
      dataIndex: 'fullName',
      width: 150,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: 200,
    },
    {
      title: 'Chức vụ',
      width: 200,
      dataIndex: 'jobTitle',
    },
    {
      title: 'Bộ phận',
      width: 200,
      dataIndex: 'departmentName',
    },
    {
      title: 'Email người quản lý',
      dataIndex: 'managerEmail',
      width: 200,
      render: (_: any, record: IUser) => {
        return <>{record?.managerEmail}</>;
      },
    },
    {
      title: 'Các quyền',
      dataIndex: 'role',
      width: 200,
      render: (record: any) =>
        record?.map((role_code: any) => {
          const role: any = roles.find((item: any) => item.role === role_code);
          return (
            <Tag color="blue" key={role_code}>
              {/* {convertRole(role)} */}
              {role ? role.role_name : ''}
            </Tag>
          );
        }),
    },
    {
      title: 'Nhóm quyền',
      dataIndex: 'groups',
      width: 200,
      // render: (record: any) =>
      //   record?.map((role: any) => (
      //     <Tag color="blue" key={role}>
      //       {/* {convertRole(role)} */}
      //       {role}
      //     </Tag>
      //   )),
    },
    {
      title: 'Plant quản lý',
      dataIndex: 'plantCodesManaging',
      width: 150,
      render: (record: any) => {
        return record?.join('; ');
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right',
      align: 'center',
      width: 100,
      render: (_: any, record: any) => {
        return (
          <Space className="text-lg">
            <Tooltip placement="top" title={'Phân quyền'}>
              <EditIcon
                onClick={() => {
                  setCurrentUser(record);
                  setIsPermissionModalVisible(true);
                }}
                className="cursor-pointer text-[#00538f]"
              />
            </Tooltip>

            {/* <Tooltip placement="top" title={'Cập nhật thông tin'}>
              <EditIcon
                onClick={() => {
                  setIsUserPlantModalVisible(true);
                  setCurrentUser(record);
                }}
                className="cursor-pointer text-[#00538f]"
              />
            </Tooltip> */}
            {/* <Tag
              color="blue"
              className="cursor-pointer mb-1"
              onClick={() => {
                setIsPermissionModalVisible(true);
                setCurrentUser(record);
              }}
            >
              Phân quyền
            </Tag> */}
            {/* <Tag
              color="cyan"
              className="cursor-pointer"
              onClick={() => {
                setIsUserPlantModalVisible(true);
                setCurrentUser(record);
              }}
            >
              Cập nhật thông tin
            </Tag> */}
          </Space>
        );
      },
    },
  ];
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  useEffect(() => {
    setTitle('Phân Quyền');
    setBreadcrumb([{ title: 'Phân Quyền' }]);
    userRefetch();
  }, [formSubmitParams, page, page_size]);

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );

    // const search: Partial<IGetUserQuery> = JSON.parse(
    //   JSON.stringify({
    //     ...values,
    //     page: 1,
    //     page_size: page_size,
    //   })
    // );
    history.push({
      pathname: '/role-based-auth',
      search: updateQueryStringParameter(location.search, {
        page: 1,
        page_size: page_size,
      }),
    });

    // check and remove item not value
    const filteredItem = Object.fromEntries(
      Object.entries(filteredData).filter(([, v]) => v !== '')
    );

    setFormSubmitParams(filteredItem);
  };

  return (
    <MainLayout isLoading={setUserPlantLoading}>
      {/* <Input
        placeholder="Tìm kiếm theo Email"
        style={{ width: 170 }}
        onChange={(e) => handleSearchUser(e)}
      /> */}

      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              bgColor={'bg-white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              onClick={() => {
                setIsImportModalVisible(true);
              }}
            >
              Import
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content className="main-content">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={6} className="h-[80px]">
              <Form.Item label="Họ và tên" name="fullName">
                <Input
                  allowClear
                  size="large"
                  placeholder="Họ và tên"
                  className="w-full"
                />
              </Form.Item>
            </Col>

            <Col span={6} className="h-[80px]">
              <Form.Item label="Email" name="email">
                <Input
                  allowClear
                  size="large"
                  placeholder="Email"
                  className="w-full"
                />
              </Form.Item>
            </Col>

            <Col span={6} className="h-[80px]">
              <Form.Item label="Chức vụ" name="jobTitleCode">
                <Input
                  allowClear
                  size="large"
                  placeholder="Chức vụ"
                  className="w-full"
                />
              </Form.Item>
            </Col>

            {/* <Col span={6} className="h-[80px]">
              <Form.Item label="Bộ phận" name="departmentCode">
                <Input
                  allowClear
                  size="large"
                  placeholder="Bộ phận"
                  className="w-full"
                />
              </Form.Item>
            </Col> */}

            <Col className="gutter-row" span={6}>
              <Form.Item
                label="Nhóm Quyền"
                name="userRole"
                className="mb-1.5"
                labelCol={{ style: { paddingBottom: '5px' } }}
              >
                <Select placeholder="Chọn nhóm quyền" allowClear size="small">
                  {roles?.map(
                    (item: { id: any; role: any; role_name: any }) => (
                      <Option
                        key={item?.id}
                        value={item?.role}
                        style={{ 'text-transform': 'capitalize' }}
                      >
                        {item?.role_name}
                      </Option>
                    )
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6} className="h-[80px]">
              <Form.Item label="Plant" name="plantCode">
                <Input
                  allowClear
                  size="large"
                  placeholder="Plant"
                  className="w-full"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mt-1.5"
          >
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          scroll={{ x: 1000 }}
          className="customTable"
          dataSource={data?.data}
          size="small"
          loading={getUsersLoading}
          pagination={{
            className: 'flex items-center',

            current: page,
            pageSize: page_size,
            total: data?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
        <UserModal
          isLoading={setRoleLoading}
          isModalVisible={isPermissionModalVisible}
          onCancel={() => setIsPermissionModalVisible(false)}
          handleUpdateUser={handleUpdateUser}
          currentUser={currentUser}
          groups={groupData?.data}
        />
        <UserPlantModal
          isModalVisible={isUserPlantModalVisible}
          onCancel={() => setIsUserPlantModalVisible(false)}
          handleUpdateUser={handleUpdateUserPlant}
          currentUser={currentUser}
        />
        <UserImportPlant
          handleUpdateUser={handleImportPlantASM}
          isLoading
          isModalImportVisible={isImportModalVisible}
          onCancel={() => setIsImportModalVisible(false)}
        />
      </Content>
    </MainLayout>
  );
}
